import '@babel/polyfill/noConflict';
import 'element-remove';
import 'nodelist-foreach-polyfill';
import EngineWidget from './engine-widget';
import EngineWidgetModal from './engine-widget-modal';
import EngineWidgetOffers from './engine-widget-offers';
import EngineWidgetPackages from './engine-widget-packages';
import EngineWidgetRooms from './engine-widget-rooms';

const widget = new EngineWidget();
window.RoiEngineWidget = {
    createPackageModal: trigger => new EngineWidgetPackages(widget, trigger),
    createOfferModal: trigger => new EngineWidgetOffers(widget, trigger),
    createRoomModal: trigger => new EngineWidgetRooms(widget, trigger),
    createModal: trigger => new EngineWidgetModal(widget, trigger)
};

function setWidth (element, destination) {
    let elementWidth = element.offsetWidth;
    elementWidth += 'px';
    destination.style.setProperty('width', elementWidth);
}

function loyaltyWidth (reference, element) {
    if (element !== null &&
        !reference.classList.contains('roi-search-engine--full-width') &&
        !document.body.classList.contains('bookings', 'registro')) {
        if (window.innerWidth > 820) {
            setWidth(reference, element);
        } else {
            element.attributeStyleMap.delete('width');
        }
    } else if (element !== null && document.body.classList.contains('bookings', 'registro')) {
        element.style.display = 'none';
    }
}


function initResizeObserver() {
    const roiSearchWidget = document.querySelector('.roi-search-engine'),
        roiSearchLoyalty = document.querySelector('.roi-search-engine__loyalty');

    if (roiSearchWidget && roiSearchLoyalty) {
        const resizeObserver = new ResizeObserver((items) => {
            const { width } = items[0].contentRect;
            roiSearchLoyalty.style.width = `${width}px`;
        });
        resizeObserver.observe(roiSearchWidget);
    }
}

function setCalendarStyles (reference, calendar, position) {
    const displaced = reference.closest('[class*="displaced"');
    let calendarPosition,
        calendarHeight = parseInt(getComputedStyle(calendar).getPropertyValue('height'), 10);

    calendarHeight = Math.round(calendarHeight / 2);

    if (window.innerWidth > 990) {
        if (position === 'fixed') {
            calendarPosition = reference.getBoundingClientRect().bottom;
            calendarPosition = `${Math.round(calendarPosition + calendarHeight) - 2}px`;
            calendar.style.setProperty('top', calendarPosition);
            calendar.style.setProperty('position', 'fixed');
            calendar.attributeStyleMap.delete('margin-left');
            setWidth(reference, calendar);
        } else {
            calendarPosition = reference.getBoundingClientRect().bottom + window.scrollY;

            calendarPosition = `${Math.round(calendarPosition + calendarHeight - 2)}px`;
            calendar.attributeStyleMap.delete('position');
            calendar.style.setProperty('top', calendarPosition);

            if (displaced && window.innerWidth >= 1024) {
                const containerLeft = getComputedStyle(displaced).getPropertyValue('padding-left');
                calendar.style.setProperty('margin-left', containerLeft);
            }
            setWidth(reference, calendar);
        }
    } else {
        calendar.style = '';
    }
}

function onClassChange(node, callback) {
    let lastClassString = node.classList.toString();

    const mutationObserver = new MutationObserver((mutationList) => {
        mutationList.forEach((item) => {
            const classString = node.classList.toString();
            switch (item.attributeName) {
                case 'class':
                    if (classString !== lastClassString) {
                        callback(mutationObserver);
                        lastClassString = classString;
                        break;
                    }
                    break;
                default:
                    break;
            }
        });
    });

    mutationObserver.observe(node, { attributes: true });

    return mutationObserver;
}

document.querySelector('body').addEventListener('RoiEngineReady', () => {
    const searchElement = document.querySelector('#roi-search-engine'),
        loyaltyElement = document.querySelector('.roi-search-engine__loyalty'),
        calendarTrigger = document.querySelector('.js-roicalendar-trigger'),
        calendarElement = document.querySelector('#roicalendar');

    if (searchElement !== null) {
        loyaltyWidth(searchElement, loyaltyElement);
        if (loyaltyElement !== null) {
            setTimeout(() => {
                loyaltyElement.style.display = '';
            }, 30);
            loyaltyElement.classList.remove('roi-hidden');
        }

        if (calendarElement !== null &&
            calendarTrigger.classList.contains('calendar-no-modal')) {
            calendarElement.classList.add('no-modal');
        }
    }

    calendarTrigger.addEventListener('click', (event) => {
        const elementPosition = getComputedStyle(searchElement).getPropertyValue('position');

        if (calendarElement !== null &&
            event.currentTarget.classList.contains('calendar-no-modal')) {
            setCalendarStyles(searchElement, calendarElement, elementPosition);
        }
    });

    searchElement.addEventListener('change', () => {
        const reference = searchElement.classList.contains('engine--fixed') ? searchElement.firstChild : searchElement;

        if (window.innerWidth > 767) {
            loyaltyWidth(reference, loyaltyElement);

            if (calendarElement !== null && calendarTrigger.classList.contains('calendar-no-modal')) {
                calendarElement.style.setProperty('top', searchElement.offsetHeight);
                setWidth(reference, calendarElement);
            }
        }
    });

    // check events to display/hide calendar
    if (calendarElement !== null && calendarTrigger.classList.contains('calendar-no-modal')) {
        document.addEventListener('click', (e) => {
            const elementTrigger = e.target;
            if (!e.target.closest('.js-roicalendar-trigger') &&
                !e.target.closest('#roicalendar') &&
                !elementTrigger.classList.contains('js-calendar-nav')) {
                calendarElement.classList.remove('show-calendar');
            }
        });

        const widgetFields = [
            '.js-roi-search-engine-destination-name',
            '.js-roi-search-engine-promo',
            '.js-roi-search-engine-occupancy-summary'
        ];

        widgetFields.forEach((item) => {
            const element = document.querySelector(item);

            if (element !== null) {
                element.addEventListener('focus', () => {
                    if (calendarElement.classList.contains('show-calendar')) {
                        calendarElement.classList.remove('show-calendar');
                    }
                });
            }
        });

        calendarTrigger.addEventListener('focus', (e) => {
            if (!calendarElement.classList.contains('show-calendar')) {
                const elementPosition = getComputedStyle(searchElement).getPropertyValue('position');

                if (calendarElement !== null &&
                    e.currentTarget.classList.contains('calendar-no-modal')) {
                    setCalendarStyles(searchElement, calendarElement, elementPosition);
                }
                calendarElement.classList.add('show-calendar');
            }
        });
    }

    window.addEventListener('resize', () => {
        const elementPosition = getComputedStyle(searchElement).getPropertyValue('position'),
            reference = elementPosition === 'fixed' ? searchElement.firstChild : searchElement;

        loyaltyWidth(reference, loyaltyElement);

        if (calendarElement !== null &&
            calendarTrigger.classList.contains('calendar-no-modal')) {
            setCalendarStyles(searchElement, calendarElement, elementPosition);
        }
    });

    window.addEventListener('scroll', () => {
        if (loyaltyElement !== null) {
            if (document.body.classList.contains('bookings') && document.documentElement.scrollTop > 110) {
                loyaltyElement.style.setProperty('display', 'none');
            } else {
                loyaltyElement.attributeStyleMap.delete('display');
            }
        }

        onClassChange(searchElement, (observer) => {
            if (calendarElement !== null && calendarElement.classList.contains('show-calendar')) {
                calendarElement.classList.remove('show-calendar');
                observer.disconnect();
            }
        });
    });
});

document.addEventListener('readystatechange', () => {
    const loyaltyElement = document.querySelector('.roi-search-engine__loyalty');
    if (document.readyState === 'complete' && loyaltyElement !== null) {
        // avoid show loyalty before engine is loaded
        setTimeout(() => {
            loyaltyElement.style.display = '';
        }, 30);
        loyaltyElement.classList.remove('roi-hidden');
        initResizeObserver();
    }
});

function getHotelDataById(inputId) {
    const input = document.getElementById(inputId);

    if (input && input.value) {
        return input.value;
    }
    return '';
}

function getFormattedCurrentDate() {
    const currentDate = new Date(),
        month = (currentDate.getMonth() + 1).toString().padStart(2, '0'),
        day = currentDate.getDate().toString().padStart(2, '0'),
        year = currentDate.getFullYear().toString();

    return `${month}-${day}-${year}`;
}
function ChangeDatesUtagEvent() {
    utag.link({ // eslint-disable-line
        sc_page_title: 'Resv:ChooseYourDates',
        page_type: 'choose_dates',
        page_url: window.location.href, // URl of the page
        hotel_name: getHotelDataById('id_destino-widget-0'), // Hotel name
        product_id: getHotelDataById('id_coddestino-widget-0'), // Hotel RB code
        new_date_time: getFormattedCurrentDate() // MM-DD-YYYY current date and time
    });
}

document.querySelector('body').addEventListener('RoiCalendarClosed', () => {
    if (typeof utag !== 'undefined') {
        ChangeDatesUtagEvent();
    }

    widget.formatToLangDates();
});
